import ResourcePage from "@/components/ResourcePage";

const TYPES = [
  { value: "call", label: "Anruf" },
  { value: "email", label: "E-Mail" },
  { value: "meeting", label: "Meeting" },
  { value: "note", label: "Notiz" },
  { value: "task", label: "Aufgabe" },
];

const TYPE_LABEL = Object.fromEntries(TYPES.map((t) => [t.value, t.label]));

export default function ActivitiesPage() {
  return (
    <ResourcePage
      resource="activities"
      title="Aktivitäten"
      subtitle="Alles, was heute und in den letzten Tagen passiert ist."
      singular="Aktivität"
      newButtonLabel="Aktivität erfassen"
      createDialogTitle="Aktivität erfassen"
      editDialogTitle="Aktivität bearbeiten"
      submitButtonLabel="Aktivität speichern"
      emptyDescription="Halte deine erste Aktivität fest."
      emptyCreateButtonLabel="Aktivität erfassen"
      testidPrefix="activities"
      defaultValues={{ type: "call" }}
      fields={[
        { name: "subject", label: "Betreff", type: "text", required: true },
        {
          name: "type",
          label: "Typ",
          type: "select",
          options: TYPES,
          required: true,
        },
        { name: "occurred_at", label: "Datum / Zeit", type: "datetime" },
        {
          name: "contact_id",
          label: "Person",
          type: "select",
          optionsFromResource: "contacts",
          optionLabel: (c) => `${c.first_name} ${c.last_name}`,
        },
        {
          name: "company_id",
          label: "Firma",
          type: "select",
          optionsFromResource: "companies",
        },
        {
          name: "lead_id",
          label: "Lead",
          type: "select",
          optionsFromResource: "leads",
          optionLabel: (l) => l.title,
        },
        { name: "description", label: "Beschreibung", type: "textarea", fullWidth: true, rows: 4 },
      ]}
      columns={[
        { key: "subject", label: "Betreff", render: (r) => <span className="font-medium text-gray-900">{r.subject}</span> },
        { key: "type", label: "Typ", render: (r) => TYPE_LABEL[r.type] || r.type },
        {
          key: "occurred_at",
          label: "Zeitpunkt",
          render: (r) => new Date(r.occurred_at).toLocaleString("de-DE"),
        },
      ]}
    />
  );
}
